module.exports = __webpack_public_path__ + "img/en_tis60_uninstall2.fe3dbea8.png";